module.exports = __webpack_public_path__ + "static/media/TMP4.6ebdfb21.gif";